export class AlfatronSck41 {
    constructor(socket) {
        this.socket = socket;
        this.audioChannels = {
            Mic: { vol: 48, mute: true },
            Source: { vol: 48, mute: true },
        };
        this.autoSwitch = false;
        this.firmwareVersion = '1.0.3';
        this.layout = 1;
        this.power = true;
        this.videoMatrixRoutes = {
            A: '1',
            B: '2',
            C: '3',
            D: '4',
        };
        this.asyncHandlers = [
            {
                name: 'audioMuteGet',
                regExp: />Get(Mic|Source)AudioMute/i,
                callback: (match) => {
                    const channel = match[1];
                    this.socket.send(`<${channel}AudioMute ${this.audioChannels[channel].mute ? 'True' : 'False'}`);
                },
            },
            {
                name: 'audioMuteSet',
                regExp: />Set(Mic|Source)AudioMute\s+(EN|Dis)/i,
                callback: (match) => {
                    const channel = match[1];
                    this.audioChannels[channel].mute = match[2].toLowerCase() === 'en';
                    this.socket.send(`<${channel}AudioMute ${this.audioChannels[channel].mute ? 'True' : 'False'}`);
                },
            },
            {
                name: 'audioVolGet',
                regExp: />Get(Mic|Source)VOL/i,
                callback: (match) => {
                    const channel = match[1];
                    this.socket.send(`<${channel}VOL ${this.audioChannels[channel].vol}`);
                },
            },
            {
                name: 'audioVolSet',
                regExp: />Set(Mic|Source)VOL\s+(\d+)/i,
                callback: (match) => {
                    const channel = match[1];
                    this.audioChannels[channel].vol = parseInt(match[2], 10);
                    this.socket.send(`<${channel}VOL ${this.audioChannels[channel].vol}`);
                },
            },
            {
                name: 'autoSwitchSet',
                regExp: />SetAutoSwitch (EN|DIS)/i,
                callback: (match) => {
                    this.autoSwitch = match[1].toUpperCase() === 'EN';
                    this.socket.send(`<AutoSwitch ${this.autoSwitch ? 'True' : 'False'}`);
                },
            },
            {
                name: 'powerQuery',
                regExp: />GetPowerOn/i,
                callback: (match) => {
                    this.socket.send(`<PowerOn ${this.power ? 'True' : 'False'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: />SetPowerOn (EN|Dis)/i,
                callback: (match) => {
                    this.power = match[1].toUpperCase() === 'EN';
                    this.socket.send(`<PowerOn ${this.power ? 'True' : 'False'}`);
                },
            },
            {
                name: 'videoMatrixRoutesGet',
                regExp: />GetAV ([A-D])/i,
                callback: (match) => {
                    var _a;
                    const output = match[1];
                    const input = (_a = this.videoMatrixRoutes[output]) !== null && _a !== void 0 ? _a : '1';
                    this.socket.send(`<Video ${input},${output}`);
                },
            },
            {
                name: 'getStatus',
                regExp: />GetStatus/i,
                callback: (match) => {
                    const responses = [
                        `<V${this.firmwareVersion}`,
                        `<Video`,
                        `OUT A B C D`,
                        `IN ${this.videoMatrixRoutes['A']} \
                        ${this.videoMatrixRoutes['B']} \
                        ${this.videoMatrixRoutes['C']} \
                        ${this.videoMatrixRoutes['D']}`,
                        `<AudioSource 4`,
                        `<InPortEdid 1,2`,
                        `<InPortEdid 3,2`,
                        `<InPortEdid 4,2`,
                        `<KeyboardLock False`,
                        `<RS232Baudrate 5`,
                        `<MvMode ${this.layout}`,
                        `<HdcpHdmiOutput 1`,
                        `<AudioMix True`,
                        `<MicAudioMute ${this.audioChannels['Mic'].mute}`,
                        `<MicVOL ${this.audioChannels['Mic'].vol}`,
                        `<SourceAudioMute ${this.audioChannels['Source'].mute}`,
                        `<SourceVOL ${this.audioChannels['Source'].vol}`,
                        `<FullModeAudioSwitch True`,
                        `<AutoCec True`,
                        `<AutoCommand True`,
                        `<AutoStandby False`,
                        `<PanelCEC 600`,
                        `<Input3Type Dp`,
                        `<Input4Type H`,
                        `<IpAddress: 192.168.7.2`,
                        `<SubNetMask: 255.255.255.0`,
                        `<GateWay: 192.168.7.1`,
                    ];
                    responses.forEach(resp => this.socket.send(resp));
                },
            },
            {
                name: 'videoMatrixRoutesSet',
                regExp: />SetAV (\d+),\s*([A-D])/i,
                callback: (match) => {
                    const input = match[1];
                    const output = match[2];
                    this.videoMatrixRoutes[output] = input;
                    this.socket.send(`<AV ${input},${output}`);
                },
            },
        ];
    }
}
AlfatronSck41.emulatorType = 'socketEmulator';
AlfatronSck41.key = '-O0AV5n6rhqNuY2MeyXf';
